var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-card"},[_c('p',{staticClass:"my-card_top"},[_vm._t("top")],2),_c('div',{staticClass:"my-card_middle"},[_vm._t("middle")],2),_c('div',{staticClass:"my-card_bottom"},[_vm._t("bottom")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }